import { IconArrowDown, IconArrowUp } from "@tabler/icons-react";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { Button, ButtonVariant } from "../Buttons/button.js";
import { Size } from "../helpers/helpers.js";

export interface AutoScrollResumeButtonProps {
  className?: string;
  direction?: "down" | "up";
  onResume: () => void;
}

/** Shared recovery action for transcript views that follow active playback. */
export const AutoScrollResumeButton: FC<AutoScrollResumeButtonProps> = ({
  className,
  direction = "down",
  onResume,
}) => {
  const DirectionIcon = direction === "up" ? IconArrowUp : IconArrowDown;

  return (
    <Button
      className={twMerge("shrink-0", className)}
      icon={<DirectionIcon className="size-4" />}
      size={Size.MEDIUM}
      variant={ButtonVariant.Primary}
      onClick={onResume}
    >
      Back to current
    </Button>
  );
};

/**
 * Floating variant that sticks to the bottom of the nearest scrolling
 * ancestor when rendered in flow inside the scrollable content.
 */
export const FloatingAutoScrollResumeButton: FC<
  AutoScrollResumeButtonProps
> = ({ className, direction, onResume }) => (
  <div className="pointer-events-none sticky bottom-4 z-20 flex h-0 justify-center">
    <AutoScrollResumeButton
      className={twMerge("pointer-events-auto -translate-y-full", className)}
      direction={direction}
      onResume={onResume}
    />
  </div>
);
